import { useEffect, useState } from "react"
import Table from "../Table"
import MyModal from "../MyModal"
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import Input from "../Input"
import { createCompany, deleteCompany, editCompany, getCompanyList } from "../../services/companyListApis"

const cols = [
    {
        name: "اسم کمپانی",
        colSpan: 1,
    },
    {
        name: "نام دامنه",
        colSpan: 1,
    },
    {
        name: "توکن کلودفلیر",
        colSpan: 1,
    },
    {
        name: "ایپی",
        colSpan: 1,
    },
    {
        name: "",
        colSpan: 1,
    },
]

const EditCompanyModal = ({ user, company }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            companyId: company.id,
            name: form.get("company-name"),
            cloudfToken: form.get("cloudf-token"),
            domainIp: form.get("domain-ip"),
        }

        if (user) {
            toast
                .promise(editCompany(data), {
                    pending: "درحال ویرایش",
                    success: "ویرایش شد",
                })
                .catch((err) => {
                    if (err.response?.status == 403) {
                        toast.error(err.response.data)
                    }
                    console.error(err)
                })
        }
    }

    return (
        <>
            <button
                onClick={toggleModal}
                className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
            >
                <AiOutlineEdit size="1.7em" className=" hover:fill-yellow-400" />
            </button>
            <MyModal width="400px" height="300px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input
                            label="نام کمپانی"
                            type="text"
                            name="company-name"
                            placeholder="نام"
                            required={true}
                            defaultValue={company.name}
                        />
                    </div>
                    <div>
                        <Input
                            label="نام دامنه"
                            type="text"
                            name="domain-name"
                            placeholder="دامنه"
                            required={true}
                            defaultValue={company.domain_name}
                        />
                    </div>
                    <div>
                        <Input
                            label="ایپی دامنه"
                            name="domain-ip"
                            placeholder="ایپی"
                            defaultValue={company.domain_ip}
                            required={true}
                        />
                    </div>
                    <div>
                        <Input
                            label="توکن کلودفلر"
                            name="cloudf-token"
                            placeholder="توکن"
                            defaultValue={company.cloudf_token}
                            required={true}
                        />
                    </div>

                    <button type="submit" className="mt-5 w-full styled-button border">
                        ویرایش کمپانی
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const AddCompanyModal = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            name: form.get("company-name"),
            domainName: form.get("domain-name"),
            cloudfToken: form.get("cloudf-token"),
            domainIp: form.get("domain-ip"),
        }

        if (user) {
            toast
                .promise(createCompany(data), {
                    pending: "درحال اضافه کردن",
                    success: "اضافه شد",
                })
                .catch((err) => {
                    if (err.response?.status == 403) {
                        toast.error(err.response.data)
                    }
                    console.error(err)
                })
        }
    }

    return (
        <>
            <button onClick={toggleModal} className="flex gap-2 w-32 pl-2 styled-button mr-3 mb-3">
                <img src="assets/icons/square-plus.svg" className="h-5 w-5" />
                اضافه کمپانی
            </button>
            <MyModal width="400px" height="300px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input label="نام کمپانی" type="text" name="company-name" placeholder="نام" required={true} />
                    </div>
                    <div>
                        <Input label="نام دامنه" type="text" name="domain-name" placeholder="دامنه" required={true} />
                    </div>
                    <div>
                        <Input label="ایپی دامنه" name="domain-ip" placeholder="ایپی" required={true} />
                    </div>
                    <div>
                        <Input label="توکن کلودفلر" name="cloudf-token" placeholder="توکن" required={true} />
                    </div>

                    <button type="submit" className="mt-5 w-full styled-button border">
                        ساخت کمپانی
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const CompanyList = ({ user }) => {
    const [companyList, setCompanyList] = useState(null)
    const updateUi = () => {
        if (user) {
            getCompanyList()
                .then(({ data }) => {
                    data = data.map((company) => {
                        let obj = {
                            name: company.name,
                            domain_name: company.domain_name,
                            cloudf_token: company.cloudf_token,
                            domain_ip: company.domain_ip,
                            more: (
                                <div className="flex gap-3 justify-end">
                                    <EditCompanyModal user={user} company={company} />
                                    <button
                                        onClick={() => {
                                            toast.promise(deleteCompany(company.id), {
                                                success: "حذف شد",
                                                pending: "درحال حذف",
                                            })
                                        }}
                                        className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
                                    >
                                        <AiOutlineDelete size="1.7em" className=" hover:fill-red-400" />
                                    </button>
                                </div>
                            ),
                        }
                        return obj
                    })
                    setCompanyList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    // useEffect(() => {
    //     updateUi()
    // }, [user])

    useEffect(() => {
        updateUi()
        const interval = setInterval(updateUi, 5000)
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <AddCompanyModal user={user} />
            <Table cols={cols} rows={companyList} paging={{ maxRows: 10 }} />
        </>
    )
}

export default CompanyList
